import {
  CLEAR_GROUP_ERROR,
  CLEAR_GROUP_ERRORS,
  CLEAR_PAGE,
  CLOSE_FILE_UPLOAD,
  CONFIRM_DELETE_ALL_ROLE_ASSIGNMENTS,
  DELETE_CONFIGURATION,
  DOMAIN_OPTIONS_CHANGE,
  FETCH_CA,
  FETCH_DATA,
  FETCH_ROLES,
  GROUP_SEARCH_DATA_CHANGE,
  OPEN_FILE_UPLOAD,
  SAVE_FORM,
} from './constants';

export function fetchCA() {
  return {
    type: FETCH_CA,
  };
}

export function fetchData() {
  return {
    type: FETCH_DATA,
  };
}

export function fetchRoles() {
  return {
    type: FETCH_ROLES,
  };
}

export function saveForm(args) {
  return {
    type: SAVE_FORM,
    payload: args,
  };
}

export function domainOptionsChange(args) {
  return {
    type: DOMAIN_OPTIONS_CHANGE,
    payload: { options: args },
  };
}

export function clearPage() {
  return {
    type: CLEAR_PAGE,
  };
}

export function groupSearchDataChange(args) {
  return {
    type: GROUP_SEARCH_DATA_CHANGE,
    payload: args,
  };
}

export function deleteConfiguration(args) {
  return {
    type: DELETE_CONFIGURATION,
    payload: args,
  };
}

export function openFileUpload() {
  return {
    type: OPEN_FILE_UPLOAD,
  };
}

export function closeFileUpload() {
  return {
    type: CLOSE_FILE_UPLOAD,
  };
}

export function confirmDeleteAllRoleAssignments() {
  return {
    type: CONFIRM_DELETE_ALL_ROLE_ASSIGNMENTS,
  };
}

export function clearGroupError(args) {
  return {
    type: CLEAR_GROUP_ERROR,
    payload: args,
  };
}

export function clearGroupErrors(args) {
  return {
    type: CLEAR_GROUP_ERRORS,
    payload: args,
  };
}
